import { useRouter } from 'next/router'

import { TPlanSummary } from 'common/cms-types'
import useShoppingBag from 'common/useShoppingBag'
import useWindowSize from 'components/util/useWindowSize'
import WhatsAppPrice from 'components/WhatsApp/WhatsAppPrice'
import RightRobotCard from '../cards/new/common/RightRobotCard'

const UnlockW4BFeaturesCard = ({
  planSummary,
}: {
  planSummary: TPlanSummary
}) => {
  const size = useWindowSize()
  const router = useRouter()
  const { addPlan } = useShoppingBag()

  const onBuyClick = () => {
    addPlan(planSummary.slug, 'month', planSummary)
    router.push('/checkout')
  }

  return (
    <RightRobotCard
      image={{
        alt: 'Robot in WhatsApp paint',
        desktop: {
          src: '/images/new/whatsapp/wa-messages.png',
          dimensions: {
            width: 867,
            height: 1040,
          },
        },
        mobile: {
          src: '/images/new/whatsapp/wa-messages-mobile.png',
          dimensions: {
            width: 361,
            height: 421,
          },
        },
      }}
      imageStyle={{
        height: '100%',
        objectFit: 'contain',
        maxWidth: '100%',
      }}
      imageContainerWidth={size.isLgOrHigher ? '60%' : '100%'}
      imageContainerContentBottom={
        <WhatsAppPrice
          className='d-lg-none mb-5 mx-4'
          onBuyNow={onBuyClick}
          planSummary={planSummary}
        />
      }
    >
      <div className='d-flex flex-column flex-1 px-4 pt-8 pt-lg-13 pb-lg-10 pb-10 ps-lg-15 me-lg-n32 z-index-1'>
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-36-48 d-block pe-5'>
          Unlock all of these features for your business in minutes
        </h2>
        <span className='fs-fluid-18-22 lh-132 fw-semibold'>
          Sign up for your WhatsApp for Business number, follow our easy set-up
          guides and get started today.
        </span>
        <WhatsAppPrice
          className='mt-lg-29 d-none d-lg-block'
          onBuyNow={onBuyClick}
          planSummary={planSummary}
        />
      </div>
    </RightRobotCard>
  )
}

export default UnlockW4BFeaturesCard
